/****************************
* メインFV フェードスライダー
****************************/
(() => {
  // 万一ファイルが二重に読み込まれても二重登録しない
  if (window.fvFadeSliderLoaded) return;
  window.fvFadeSliderLoaded = true;

  function initFvSlider(slider) {
    if (slider.dataset.ready) return;
    slider.dataset.ready = 'true';

    const slides = slider.querySelectorAll('.fv_slide');
    const indicators = slider.querySelectorAll('.fv_indicator');
    const swipeArea = slider.querySelector('.fv_slides');

    let current = 0;
    const total = slides.length;
    const delay = Number(slider.dataset.delay) || 5000;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const useAutoplay = slider.dataset.autoplay === 'true' && total > 1 && !reduceMotion;
    let timer = null;

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      indicators.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
      current = index;
    }

    function nextSlide() {
      showSlide((current + 1) % total);
    }

    function prevSlide() {
      showSlide((current - 1 + total) % total);
    }

    function stopAutoplay() {
      clearInterval(timer);
      timer = null;
      slider.classList.remove('is-autoplay');
    }

    function startAutoplay() {
      if (!useAutoplay) return;
      stopAutoplay();
      void slider.offsetWidth; // ゲージのアニメーションを最初からやり直す
      slider.classList.add('is-autoplay');
      timer = setInterval(nextSlide, delay);
    }

    // 手動で切り替えたら自動再生のカウントをリセット
    indicators.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showSlide(index);
        startAutoplay();
      });
    });

    /* ===== スワイプ（SP）・ドラッグ（PC）で切り替え ===== */
    const SWIPE_THRESHOLD = 50; // この距離（px）以上横に動かしたら切り替える
    let startX = 0;
    let startY = 0;
    let isPointerDown = false;
    let isSwiped = false;

    if (swipeArea && total > 1) {
      swipeArea.addEventListener('pointerdown', e => {
        if (e.pointerType === 'mouse' && e.button !== 0) return; // 左クリック以外は無視
        isPointerDown = true;
        isSwiped = false;
        startX = e.clientX;
        startY = e.clientY;
      });

      swipeArea.addEventListener('pointerup', e => {
        if (!isPointerDown) return;
        isPointerDown = false;

        const diffX = e.clientX - startX;
        const diffY = e.clientY - startY;

        // 横の移動が小さい、または縦スクロールの動きの場合は何もしない
        if (Math.abs(diffX) < SWIPE_THRESHOLD || Math.abs(diffX) < Math.abs(diffY)) return;

        isSwiped = true;
        if (diffX < 0) {
          nextSlide(); // 左へスワイプ → 次のスライド
        } else {
          prevSlide(); // 右へスワイプ → 前のスライド
        }
        startAutoplay();
      });

      // ブラウザのスクロールに切り替わった場合や、エリア外に出た場合はリセット
      swipeArea.addEventListener('pointercancel', () => {
        isPointerDown = false;
      });
      swipeArea.addEventListener('pointerleave', () => {
        isPointerDown = false;
      });

      // スワイプ直後のクリックではリンクを開かない
      swipeArea.addEventListener('click', e => {
        if (!isSwiped) return;
        e.preventDefault();
        e.stopPropagation();
        isSwiped = false;
      }, true);

      // PCで画像やリンクをドラッグしたときの、ブラウザ標準のドラッグ動作を止める
      swipeArea.addEventListener('dragstart', e => {
        e.preventDefault();
      });
    }

    slider.fvSlider = { showSlide, startAutoplay, stopAutoplay };

    // 初期化
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('.fv_fade_slider').forEach(initFvSlider);
  }

  // 読み込みのタイミングに関係なく初期化する
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ===== テーマエディタ対応 ===== */
  document.addEventListener('shopify:section:load', e => {
    e.target.querySelectorAll('.fv_fade_slider').forEach(initFvSlider);
  });

  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('.fv_fade_slider').forEach(slider => {
      if (slider.fvSlider) slider.fvSlider.stopAutoplay();
    });
  });

  // ブロック選択時はそのスライドを表示して停止
  document.addEventListener('shopify:block:select', e => {
    const slider = e.target.closest('.fv_fade_slider');
    if (!slider || !slider.fvSlider) return;
    const index = Array.from(slider.querySelectorAll('.fv_slide')).indexOf(e.target);
    slider.fvSlider.stopAutoplay();
    if (index > -1) slider.fvSlider.showSlide(index);
  });

  document.addEventListener('shopify:block:deselect', e => {
    const slider = e.target.closest('.fv_fade_slider');
    if (slider && slider.fvSlider) slider.fvSlider.startAutoplay();
  });
})();